/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';
import {ApiConfig} from "../../api";
import {Injectable} from '@angular/core';
import {AdnHttpService} from '../../../util/adn-http.service';
import {AdnHttpSender, createAdnHttpResourceSender} from '../../../util/create-adn-http-resource';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';



@Injectable()
export class VersionHistoryResource {
  private readonly uri = ApiConfig.obtain().getVersionedInternalUri('versionhistory');
  private readonly send: AdnHttpSender;

  constructor(
    AdnHttp: AdnHttpService,
    authHttpInterceptor: AuthHttpInterceptorService,
    ApiErrorHandler: ApiErrorHandlerService
  ) {
    this.send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  }

  get(id: string, type: string, page = 1, pageSize = 30) {
    return this.send({
      method: 'GET',
      url: this.uri,
      params: _.assign({}, {id: id, type: type, pageSize: pageSize, page: page})
    });
  }
}
